(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('model-equation', {
            parent: 'entity',
            url: '/model-equation?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.modelEquation.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/model-equation/model-equations.html',
                    controller: 'ModelEquationController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('modelEquation');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('model-equation-detail', {
            parent: 'entity',
            url: '/model-equation/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.modelEquation.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/model-equation/model-equation-detail.html',
                    controller: 'ModelEquationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('modelEquation');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ModelEquation', function($stateParams, ModelEquation) {
                    return ModelEquation.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('model-equation.new', {
            parent: 'model-equation',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/model-equation/model-equation-dialog.html',
                    controller: 'ModelEquationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                expression: null,
                                label: null,
                                isMeasurement: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('model-equation', null, { reload: true });
                }, function() {
                    $state.go('model-equation');
                });
            }]
        })
        .state('model-equation.edit', {
            parent: 'model-equation',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/model-equation/model-equation-dialog.html',
                    controller: 'ModelEquationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ModelEquation', function(ModelEquation) {
                            return ModelEquation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('model-equation', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('model-equation.delete', {
            parent: 'model-equation',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/model-equation/model-equation-delete-dialog.html',
                    controller: 'ModelEquationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ModelEquation', function(ModelEquation) {
                            return ModelEquation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('model-equation', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
